import React from 'react';
import { Hidden } from '€components/Hidden';
import DashboardSideBar from '../../components/DashboardSideBar/DashboardSideBar';
// import TopLevelNavigation from '../../components/TopLevelNavigation';
import PageLayout, { PageLayoutProps } from '../PageLayout';
import { PostAuthContentLayout } from '../PostAuthLayout/PostAuthLayout';

const DashboardLayout = (props: PageLayoutProps) => {
    return (
        <PageLayout
            headerComponent={DashboardSideBar}
            contentComponent={PostAuthContentLayout}
            flexDirection="row"
            {...props}
        />
    );
};

export default DashboardLayout;
